exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-field[data-v-17a86f48]{height:100px}.note-detail[data-v-17a86f48]{transition:max-height .7s;max-height:60px;overflow:hidden}.note-wrap:hover .note-detail[data-v-17a86f48]{max-height:157px;overflow:auto}.note-wrap[data-v-17a86f48]{padding-left:10px;border-left:1px dashed #6f2971;position:relative}.note-wrap[data-v-17a86f48]:before{content:\"\";display:inline-block;width:8px;height:8px;border-radius:16px;background-color:#6f2971;position:absolute;left:-4px;top:10px}.notes_list_container[data-v-17a86f48]{padding-left:5px}", ""]);

// exports
